import { Navigate, useLocation } from "react-router-dom";
import { clearStaleAuthSession, hasActiveAuthSession } from "../../utils/authSession";

export default function AuthRequiredRoute({ children }) {
    const location = useLocation();

    if (!hasActiveAuthSession()) {
        clearStaleAuthSession();
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
}
